import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/background.png";
import MTCGameLimited from "../../components/MTCGameLimited";
import MTCCalculator from "../../components/MTCCalculator";
import { Button } from "../../../../globals/components/button";
import { navigate } from "@reach/router";
import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";
import { Container } from "@material-ui/core";
import Checkbox from "../../../../globals/components/Checkbox";

// GLOBALS
var generatedQuestions = false;
var qNum = 0;
var questionMode = true;
var modeText = "ANSWER";

console.log("mtc limited mode");
// New Global Object for Submission Data
var $gameData = {
    qAnswers: [],
    correctQuestions: [],
    incorrectQuestions: [],
};
//

//DEBUG STUFF
// Function to compile and log the current submission payload details
function DebugSubmissionPayload(context, questionCount) {
    console.groupCollapsed(`🛑 SUBMISSION DEBUG: ${context}`);
    console.log(`QNum (Current Index): ${qNum}`);
    console.log(`Expected Total Count: ${questionCount}`);
    console.log(`Actual QAnswers Count: ${$gameData.qAnswers.length}`);
    console.log(`Actual Correct Count: ${$gameData.correctQuestions.length}`);
    if ($gameData.qAnswers.length > 0) {
        console.log(`Last QAnswer:`, $gameData.qAnswers.slice(-1));
    }
    console.groupEnd();
}

function Skip() {
  qNum = 24;
}
//DEBUG STUFF

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function GenerateRandomUnique(min, max, list) {
  let num = Math.floor(Math.random() * (max - min + 1)) + min;
  let notUsed = true;
  for (let i = 0; i < list.length; i++) {
    if (list[i] == num){
      notUsed = false;
    }
  }
  if (notUsed){
    return num;
  }else{
    return GenerateRandomUnique(min,max,list);
  }
}


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function getAnswer(calculation) {
  return 1;
}

function getWrongAnswer(correctAnswer, existingWrongAnswers) {
  return 0;
}


function sleep(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds) {
      break;
    }
  }
}




function CreateUniqueQuestion(listOfQuestions) {
  var number1;
  var number2;
  var answer;
  number1 = Math.floor(Math.random() * 11) + 2;
  number2 = Math.floor(Math.random() * 11) + 2;
  answer = number1 * number2;

  var duplicate = false;

  for (var i = 0; i < listOfQuestions.length; i++) {
    //console.log("comparing " + listOfQuestions[i].answer + " with " + answer)
    if (listOfQuestions[i].answer == answer) {
      //console.log("found duplicate")
      duplicate = true;
      break;
    }
  }
  var questionObj = {
    topic_id: "MTC" + number1,
    number1: number1,
    number2: number2,
    answer: answer,
  };

  if (duplicate)
    return CreateUniqueQuestion(listOfQuestions);
  else {
    //console.log(questionObj);
    return questionObj;
  }
}

var questions;
var access;
//var topics

export default function Rating({ ...props }) {

  const { state: authState } = useAuth();
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [timer, setRemainingTime] = useState(
    props.timer ? props.timer : 6
  );
  const [submitted, setSubmitted] = useState(false);
  const [qAnswers, setQAnswers] = useState([]);
  const [options, setOptions] = useState(props.options ? props.options : "");
  const[realoptions, setRealOptions] = useState([]);

  const [canSubmit, setCanSubmit] = useState(false);
  // NOTE: isFinished state is no longer used for rendering, but kept for clarity in submission logic
  const [isFinished, setIsFinished] = useState(false); 
  //const [questions, setQuestions] = useState([]);
  //const examples = props.gameCalculations.map(calc =>
  //  calc.example_question.split(" ")
  //);
  const [currentQuestion, setCurrentQuestion] = useState([]);

  const [displayValue, setDisplayValue] = useState("");

  //ACCESSABILITY
  const [optionsMenu, setOptionsMenu] = useState(true);
  const [optionsColour, setOptionsColour] = useState("black");
  const [obgcolor, setBgColor] = useState("white");
  const [otextcolor, setTextColor] = useState("black");
  const [otextcolor2, setTextColor2] = useState("white");

  const [optionsFontSize, setOptionsFontSize] = useState("100px");
  var colourTypes = ["black","yellow","blackblue","blackpeach","bluecream"];


  //topics = props.topics;
  //console.log(topics);

  useEffect(() => {
    console.log("INITIALIZATION: Running once.");
    setRealOptions(options.split("|"));
    generatedQuestions = false;
      if (generatedQuestions == false) {
      console.log("QUESTION GEN: Starting question generation.");
      console.log("I already have: " + questions);
      // This call uses the internal CreateMTCQuestions function below
      questions = CreateMTCQuestions()
      console.log(questions);
      qNum = 0;
      $gameData.qAnswers = [];
      $gameData.correctQuestions = [];
      $gameData.incorrectQuestions = [];
      console.log("QUESTION GEN: Questions created and globals reset.");
    }
  }, []);



  function CreateMTCQuestions() {
    var qs = [];
    //create enough questions with the topics selected
    var possibleNumbers = props.possibleNumbers;
  
    for (let i = 0; i < possibleNumbers.length; i++) {
      let number = possibleNumbers[i];
      let num2u = []
      for (let x = 1; x < 5; x++) {//4 minimum of each
        let num2 = GenerateRandomUnique(2,12,num2u);
        num2u.push(num2);
        let answer = number * num2; // Changed var answer to let
        var questionObj = {
        topic_id: "MTC" + number,
        number1: number,
        number2: num2,
        answer: answer,
      };
      qs.push(questionObj)
      }
    }
  
    //then generate the rest
    while (qs.length < props.questionCount){
      var number1;
      var number2;
      var answer;
      //make sure minimum of 4 questions of each 
      number1 = possibleNumbers[GenerateRandom(0,possibleNumbers.length-1)];
      number2 = GenerateRandom(1,12);
      answer = number1 * number2;
      var questionObj = {
        topic_id: "MTC" + number1,
        number1: number1,
        number2: number2,
        answer: answer,
      };
      qs.push(questionObj)
    }

    shuffleArray(qs);

    access = props.access;
    
    console.log(`QUESTION GEN: Final question array length: ${qs.length}`);
  
    generatedQuestions = true;
    return qs;
  
  
  }

  function TimerCheckResult(value) {
    if (questionMode == false) { 
        console.log("[TIMER] Skipping TimerCheckResult: Not in questionMode.");
        return; 
    }

    let questionObject = questions[qNum];
    if (!questionObject) { 
        console.error(`[TIMER] Error: questionObject is undefined for qNum ${qNum}. Ignoring call.`);
        return; 
    } 
    
    // Sanitize the input value for the answer field (e.g., turn undefined/null into empty string)
    let finalAnswer = value === null || value === undefined ? "" : value; 
    
    let isCorrect = false; // Initialize the main correctness flag
    
    // Check if an answer was submitted AND if it matches the true answer
    if (finalAnswer !== "" && parseInt(questionObject.answer) === parseInt(finalAnswer)) {
        isCorrect = true;
    }
    
    // Create the dupeQuestion object for topic-level tracking
    let dupeQuestion = {
        answer: questionObject.answer,
        number1: questionObject.number1,
        number2: questionObject.number2,
        topic_id: questionObject.topic_id,
        num_asked: 0,
        num_correct: 0, // Will be updated below
    };
    
    // Create the qa object for the general answers array
    let qa = {
        question: questionObject.number1 + " x " + questionObject.number2,
        correct: isCorrect, // <<< CORRECTLY ASSIGNS CALCULATED isCorrect
        answer: finalAnswer, 
        timeTaken: props.defaultTimer - timer
    };

    // 1. DATA STORAGE: Push the general answer data immediately
    $gameData.qAnswers.push(qa);
    console.log(`[TIMER] Q${qNum + 1}: Pushed data for timeout. Total answers: ${$gameData.qAnswers.length}`);
    
    // CRITICAL LOGIC: Conditionally push dupeQuestion to the correct topic array
    if (isCorrect) {
        // Correct answer: set num_correct to 1 and push to the correct list
        dupeQuestion.num_correct = 1;
        $gameData.correctQuestions.push(dupeQuestion); 
        setCorrectQuestions(prev => [...prev, dupeQuestion]);
        // Timer timeout logic often omits score/combo updates for correct answers
        // to still enforce a penalty, but we record the correctness in the data.
    } else {
        // Incorrect or Unanswered (finalAnswer == ""): set num_correct to 0 and push to the incorrect list
        dupeQuestion.num_correct = 0;
        $gameData.incorrectQuestions.push(dupeQuestion);
        setIncorrectQuestions(prev => [...prev, dupeQuestion]);
        // Score/Combo updates for incorrect timeout (penalty logic):
        // setScore(prevScore => prevScore + 0); // (Original: no score increase)

        if (combo === 0 && score >= 10) {
            //setScore(score - 1); // Penalty commented out by original dev
        } else {
            setCombo(0); // Reset combo
        }

        // Add to feedback array
        let result = {
            topic_id: questionObject.topic_id,
            question: questionObject.number1 + " x " + questionObject.number2,
            correct: questionObject.answer,
            incorrect: finalAnswer
        };
        setFeedback(prevFeedback => [...prevFeedback, result]);
    }
    
    // 3. Game Flow Logic
    const isEndOfGame = $gameData.qAnswers.length >= props.questionCount;

    if (!isEndOfGame) {
        qNum = qNum + 1;
        console.log(`[TIMER] Advancing qNum to: ${qNum}`);
        if (access == ""){
            setRemainingTime(3);
        }else{
            setRemainingTime(999999);
        }
        questionMode = false;
        modeText = "WAIT";
    } else {
        // Game is finished, submit data
        console.log("[TIMER] Game End triggered. Submitting payload.");
        
        // DEBUG CALL BEFORE SUBMISSION
        // DebugSubmissionPayload("TimerCheckResult FINAL SUBMISSION", props.questionCount); 

        // GAME END SUBMISSION
        SubmitTopics($gameData.correctQuestions, $gameData.incorrectQuestions, $gameData.qAnswers, authState, submitted, setSubmitted, props); 
        
        // Final state change: Advance qNum to trigger MTCGameLimited to switch views
        qNum = qNum + 1;
        return; 
    }
}

  async function timeoutDisplay(value)
  {
    // This is called onChange, keeping it simple as it only updates the display value
    setDisplayValue(value);
  }


  async function checkResult(value, callback) {
    setCanSubmit(false);
    
    let questionObject = questions[qNum];
    if (!questionObject) { 
        console.error(`checkResult Error: questionObject is undefined for qNum ${qNum}`);
        return; 
    }
    
    let isCorrect = true;
    let dupeQuestion = {
        answer: questionObject.answer,
        number1: questionObject.number1,
        number2: questionObject.number2,
        topic_id: questionObject.topic_id,
        num_asked: 0,
        num_correct: 0,
    };

    if (value) {
        if (parseInt(questionObject.answer) !== parseInt(value)) {
            isCorrect = false;
        }

        let qa = {
            question: questionObject.number1 + " x " + questionObject.number2,
            correct: isCorrect,
            answer: value
        }
        
        // 1. DATA STORAGE: Push data immediately
        $gameData.qAnswers.push(qa);
        console.log(`[CHECK] Q${qNum + 1}: Pushed data for user submission. Total answers: ${$gameData.qAnswers.length}`);

        // CRITICAL FIX: Base end-game logic on array length
        const isEndOfGame = $gameData.qAnswers.length >= props.questionCount; 

        
        if (isCorrect) {
            dupeQuestion.num_correct = 1;
            $gameData.correctQuestions.push(dupeQuestion);
            setCorrectQuestions(prev => [...prev, dupeQuestion]);
            
            // State updates for score/UI
            setScore(prevScore => prevScore + 1); 
            setCombo(prevCombo => {
                const nextCombo = prevCombo + 1;
                if (nextCombo > maxCombo) {
                    setMaxCombo(nextCombo);
                }
                return nextCombo;
            });
            setFeedback(prevFeedback => {
                return prevFeedback.filter(() => true); 
            });
        } else {
            isCorrect = false;
            dupeQuestion.num_correct = 0;
            $gameData.incorrectQuestions.push(dupeQuestion);
            setIncorrectQuestions(prev => [...prev, dupeQuestion]);
            
            if (combo === 0 && score >= 10) {
              //setScore(score - 1); 
            } else {
              setCombo(0);
            }

            let result = {
              topic_id: questionObject.topic_id,
              question: questionObject.number1 + " x " + questionObject.number2,
              correct: questionObject.answer,
              incorrect: value
            };
            setFeedback(prevFeedback => [...prevFeedback, result]);
        }

        // 2. Game Flow Logic & Submission
        if (!isEndOfGame) {
            qNum = qNum + 1;
            console.log(`[CHECK] Advancing qNum to: ${qNum}`);
            if (access == ""){
              setRemainingTime(3);
            }else{
              setRemainingTime(999999);
            }
            questionMode = false;
            modeText = "WAIT";
        } else {
            // Game is finished, submit data, and rely on MTCGameLimited to detect qNum >= questionCount
            console.log("[CHECK] Game End triggered. Submitting payload.");
            // DEBUG CALL BEFORE SUBMISSION
            DebugSubmissionPayload("checkResult FINAL SUBMISSION", props.questionCount); 

            // GAME END SUBMISSION (using the guaranteed complete global data)
            SubmitTopics($gameData.correctQuestions, $gameData.incorrectQuestions, $gameData.qAnswers, authState, submitted, setSubmitted, props); 
            
            // Final state change: Advance qNum to trigger MTCGameLimited to switch views
            qNum = qNum + 1;
            return; 
        }
    }
}

  function NextQuestion() {
    setCanSubmit(true);
    setDisplayValue("");
    //check props.questionsanswered and set props.questionsanswered. need to pass this variable to MTCGame so it can check if you have finished the game
    setCurrentQuestion(
      questions[qNum]
    );
    console.log(`NextQuestion called. Current qNum: ${qNum}.`);
  }


  function SubmitTopics(correctData, incorrectData, qAnswersData, authState, submittedValue, setSubmittedFn, props) {
    if (submittedValue == true) {
      console.log("SUBMISSION: Already submitted, skipping.");
      return
    }
    setSubmittedFn(true);

    // Final check for debug purposes
    DebugSubmissionPayload("SubmitTopics FUNCTION ENTRY", props.questionCount);

    const totalQuestions = correctData.length + incorrectData.length;
    let average_ans_time = totalQuestions > 0 
        ? parseFloat((props.defaultTimer ? props.defaultTimer : 30) / totalQuestions).toFixed(2)
        : 0; 

    let correctByTopics = correctData.reduce((byTopics, question) => {
        byTopics[question.topic_id] = byTopics[question.topic_id] || [];
        byTopics[question.topic_id].push(question);
        return byTopics;
    }, {});
    
    let incorrectByTopics = incorrectData.reduce((byTopics, question) => {
        byTopics[question.topic_id] = byTopics[question.topic_id] || [];
        byTopics[question.topic_id].push(question);
        return byTopics;
    }, {});

    window.correctByTopics = correctByTopics;
    window.incorrectByTopics = incorrectByTopics;

    let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
        let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
        let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
        let tempAverageAnswerTime = parseFloat(average_ans_time);

        return {
          topic_key: topic_id,
          num_correct,
          num_asked: num_correct + num_incorrect,
          average_ans_time: tempAverageAnswerTime
        }
    });

    console.log(`SUBMISSION: Preparing to send payload with ${qAnswersData.length} answers.`);
    axios({
      url: `${process.env.REACT_APP_API}/submissions`,
      method: "post",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authState.access_token}`
      },
      data: {
        "homework_id": props.homework_id,
        "topicstats": topicstats,
        "game_id": 22, 
        "platform": "NETLIM|WEB" + "|" + process.env.REACT_APP_VERSION_NO,
        "questionsAnswered": JSON.stringify(qAnswersData)
      }
    });
}

  // set the first question
  useEffect(() => {
    setCanSubmit(true);
    setCurrentQuestion(questions[qNum]);
  }, []);

  useEffect(() => {
    // We rely on qNum < props.questionCount to continue the game loop
    if (qNum < props.questionCount) { 
        if (timer > 0) {
          var timerID = setTimeout(() => decrementTimer(), 1000);
          return () => {
            clearInterval(timerID);
          };
        } else {
          // Timer hit zero
          if (questionMode) {
            //if question mode then does the 3 second timer
            if (access == ""){
              setRemainingTime(3);
            }else{
              setRemainingTime(999999);
            }
            //also submits answer
            TimerCheckResult(displayValue); // Pass current state for answer capture
            modeText = "WAIT";
            questionMode = false;
          } else {
            NextQuestion();
            setRemainingTime(props.timer);
            modeText = "ANSWER";
            questionMode = true;
          }
        }
    } else {
        // qNum reached props.questionCount (Game should have ended, stop timer loops)
        console.log("endgame reached in useEffect loop fallback, clearing timer.");
        // The MTCGameLimited component should now display results because questionsAnswered (qNum) >= questionCount
        var timerID = setTimeout(() => decrementTimer(), 1000);
         // Ensure the timer stops if the game ended cleanly
        return () => {
            clearInterval(timerID);
        };
    }
    // Dependency array updated to include displayValue for accurate timing/answer capture
  }, [timer, displayValue]);

  function decrementTimer() {

    if (optionsMenu == false){
      if (timer != 999){//INFINITE TIME
        setRemainingTime(timer - 1);
      }
    }else{
      setRemainingTime(timer + 1);
    }
  }

  function AreYouSureBack(){

    if (props.homework_id != null && props.homework_id != ""){
        if (window.confirm("If you leave the task part done it will show as incomplete and you will have to start again.")){
            EarlySubmission();
        }
    }else{
        if (window.confirm("are you sure you want to exit?")){
            EarlySubmission();
        }
    }
}

  function EarlySubmission(){
    console.log("EARLY SUBMISSION: User exited early.");
    // Submit with the current global data
    if (submitted == false) {
      DebugSubmissionPayload("EarlySubmission", props.questionCount);
      SubmitTopics($gameData.correctQuestions, $gameData.incorrectQuestions, $gameData.qAnswers, authState, submitted, setSubmitted, props);
    }
    
    // Force qNum to the end so MTCGameLimited switches to the results view
    qNum = props.questionCount;
    // Force a re-render to catch the new qNum value
    setScore(s => s); 
}


  function GoBack() {
    AreYouSureBack();
  }

  function NextQuestionAccess(){
    console.log("NEXT QUESTION ACCESS");
    NextQuestion();
    setRemainingTime(props.timer);
    modeText = "ANSWER";
    questionMode = true;
  }

  function ReturnTimer(){
    if (timer < 999){
      return (<div>Time Left: <b>{timer}</b> </div> );
    }
    else{
      return "";
    }
  }

  function CanISubmit(){
    if (realoptions.includes("disable_submit") && timer < 999){
      return false;
    }else{
      return canSubmit;
    }
  }

  function onOptionSelect(option){
    setOptionsColour(option);
    //check the option
    if (option == "black"){
        setBgColor("white");
        setTextColor("black");
        setTextColor2("white");//the text for buttons
    }
    if (option == "yellow"){
        setBgColor("black");
        setTextColor("yellow");
        setTextColor2("black");//the text for buttons
    }
    if (option == "blackblue"){
        setBgColor("#92A5ED");
        setTextColor("black");
        setTextColor2("#92A5ED");//the text for buttons
    }
    if (option == "blackpeach"){
      setBgColor("#DEC4A5");
      setTextColor("black");
      setTextColor2("#DEC4A5");//the text for buttons
  }
  if (option == "bluecream"){
    setBgColor("#EAE0BE");
    setTextColor("#0F168A");
    setTextColor2("#EAE0BE");//the text for buttons
}
    
  }

  function StartGame(){
    setRemainingTime(props.timer ? props.timer : 6);
    setOptionsMenu(false);
  }

  
  if (optionsMenu == true){
    return (
      <Container>
        <h1 style={{fontSize: "50px"}}>Choose colour of page</h1>
            <Checkbox 
              label={"Black on White"}
              labelcolor="black"
              labelbackground="white"
              onChange={e => {
                  onOptionSelect("black");
              }}
              checked={
                optionsColour == "black"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Yellow on Black"}
              labelbackground="black"
              labelcolor="yellow"
              onChange={e => {
                  onOptionSelect("yellow");
              }}
              checked={
                optionsColour == "yellow"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Black on Blue"}
              onChange={e => {
                  onOptionSelect("blackblue");
              }}
              labelbackground="#92A5ED"
              labelcolor="black"
              checked={
                optionsColour == "blackblue"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Black on Peach"}
              onChange={e => {
                  onOptionSelect("blackpeach");
              }}
              labelbackground="#DEC4A5"
              labelcolor="black"
              checked={
                optionsColour == "blackpeach"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Blue on Cream"}
              onChange={e => {
                  onOptionSelect("bluecream");
              }}
              labelbackground="#EAE0BE"
              labelcolor="#0F168A"
              checked={
                optionsColour == "bluecream"
                  ? true
                  : false
                  }></Checkbox>
                  <br/>

                  <LevelButton
                   onClick={() => StartGame()}>

                    Start
                  </LevelButton>


            
      </Container>
    );
  }

  else{
  return (

    <MTCGameLimited
    optionsColour={optionsColour}
    bgcolor={obgcolor}
      questionCount={props.questionCount}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => {
        GoBack();
      }}
      quitGame={() => { GoBack();}}
      defaultTimer={props.timer}
      restart={() => {
        console.log("restart me")
        setFeedback([]);
        setCombo(0);
        setScore(0);
        $gameData.qAnswers = [];
        $gameData.correctQuestions = [];
        $gameData.incorrectQuestions = [];
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
        setRemainingTime(props.timer);
        modeText = "ANSWER";
        questionMode = true;
        qNum = 0;
        generatedQuestions = false;
        NextQuestion();
      }}
      feedback={feedback}
      questionsAnswered={qNum} // MTCGameLimited uses this prop to decide when to show results
    >
      {generatedQuestions ? (
        <Body>
          {questionMode && currentQuestion != undefined ? (
            <div style={{
              position: "relative",
              right: "-20%",
            }}>
              <MTCCalculator
              textcolor={otextcolor}
              bgcolor={obgcolor}
              textcolor2={otextcolor2}
              cansubmit = {CanISubmit()}
                currentQuestion={currentQuestion}
                onSubmitted={checkResult}
                onChange={timeoutDisplay}
              />
            </div>
          ) : (<div></div>
            )}
          <div style={{
            height: "20%"
          }}>
            {modeText == "ANSWER" ? (
              <div>
                <div style={{
                   color:otextcolor,
                  fontSize: "30px", height: "20%", position: "relative",
                  right: "-220%",
                }}>{ReturnTimer()}</div>

              </div>
            ) : (
                <div style={{
                  fontSize: "50px",
                  color:otextcolor,
                  textAlign: "center"
                }}>
                  Question: {qNum + 1}
                  {access == "access" &&
                  <div>
                  <Button onClick={()=>NextQuestionAccess()}>Next Question</Button> 
                  </div>
                  }
                </div>

              )}
          </div>
        </Body>
      ) : (<div></div>)}
    </MTCGameLimited>
  );
                }
}

const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;

const Body = styled.div`
  width: 100%;
  height: 100%;
  //background-image: url(${background});
  background-size: cover;
  background-position: 0px -1px;
  display: flex;
  justify-content: center;
  padding-top: 40px;
`;

const Result = styled.div`
  width: 100%;
  height: 100%;
  font-size: 5em;
  text-align: center;
  border: solid 2px #683d8c;
`;

const Combo = styled.div`
  background: #707070;
  width: 120px;
  height: 120px;
  border-radius: 75px;
  border: solid #636363 4px;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #fff;
  justify-content: center;
  font-weight: 600;
`;
